import { InputPhone } from 'components/input/InputPhone';
import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { Button, Radio, Row, Spacing, TextInput } from 'enable-ui';
import { GenderType } from 'enums/gender';

import { RoleKey } from 'modules/auth/core/enum';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { useProfileData } from '../core/controller';

export const UsernamePage = () => {
  const {
    handleChange,
    disabled,
    handleSubmit,
    firstName,
    lastName,
    email,
    phone,
    gender,
    searchSelectMonth,
    onChangeSearchMonths,
    onChangeGender,
    onChangeMonths,
    handleChangePhone,
    monthOfBirth,
    yearOfBirth,
    menuYears,
    menuMonths,
    roleKey,
    onChangeSearchYears,
    onChangeYears,
    searchSelectYear,
    emailStatus,
    yearErrorMessage,
  } = useProfileData();

  return (
    <div style={{ width: '100%' }}>
      <Spacing
        spacing="4xl"
        placement="bottom"
        type="margin"
        style={{ display: 'flex', alignItems: 'center', gap: 12 }}
      >
        <Row direction="column" style={{ gap: 24 }}>
          <Row style={{ gap: 12 }}>
            <div style={{ width: '50%' }}>
              <Row direction="column">
                <InputTitle title="Given name" required />
                <TextInput
                  name="firstName"
                  value={firstName}
                  onChange={handleChange}
                  maxLength={80}
                />
              </Row>
            </div>
            <div style={{ width: '50%' }}>
              <Row direction="column">
                <InputTitle title="Family name" />
                <TextInput
                  name="lastName"
                  value={lastName}
                  onChange={handleChange}
                  maxLength={80}
                />
              </Row>
            </div>
          </Row>

          <Row direction="column">
            <InputTitle title="Gender" required />
            <Row>
              {Object.keys(GenderType).map((key) => {
                const checked = gender?.toLowerCase() === key.toLowerCase();

                return (
                  <Radio
                    key={key}
                    style={{
                      marginRight: 10,
                      fontSize: 18,
                      lineHeight: '26px',
                      color: COLOR.surfaceNeutralBold['neutral-11'],
                    }}
                    checked={checked}
                    onClick={onChangeGender(key)}
                    // disabled={disabledField}
                  >
                    {key}
                  </Radio>
                );
              })}
            </Row>
          </Row>

          {roleKey !== RoleKey.BIOLOGIC_ADMIN && roleKey !== RoleKey.INSTITUTION_ADMIN && (
            <Row style={{ gap: 12 }}>
              <div style={{ width: '25%' }}>
                <InputTitle title="Month" />
                <CommonSelect
                  value={
                    menuMonths.find((item: any) => item.value === String(monthOfBirth)) || null
                  }
                  options={menuMonths.filter((ele) =>
                    ele.label.toLowerCase().includes(searchSelectMonth.value.toLowerCase()),
                  )}
                  onChange={onChangeMonths}
                  onInputChange={onChangeSearchMonths}
                  noOptionsMessage={() => 'Not Found Month'}
                  isBorderInput
                />
              </div>
              <div style={{ width: '25%' }}>
                <InputTitle title="Year" required />
                <CommonSelect
                  value={menuYears.find((item: any) => item.value === String(yearOfBirth)) || null}
                  options={menuYears.filter((ele) =>
                    ele.label.toLowerCase().includes(searchSelectYear.value.toLowerCase()),
                  )}
                  onChange={onChangeYears}
                  onInputChange={onChangeSearchYears}
                  noOptionsMessage={() => 'Not Found Year'}
                  isBorderInput
                />

                {yearErrorMessage ? (
                  <InputTitle
                    title={yearErrorMessage}
                    style={{ whiteSpace: 'nowrap', color: COLOR_CONFIG.red, paddingTop: 6 }}
                  />
                ) : null}
              </div>
            </Row>
          )}

          <InputPhone
            title="Phone number"
            value={phone}
            onChange={handleChangePhone}
            required={
              ![RoleKey.BIOLOGIC_ADMIN, RoleKey.INSTITUTION_ADMIN].includes(roleKey as RoleKey)
            }
          />

          <Row>
            <div style={{ width: '100%' }}>
              <Row direction="column">
                <InputTitle title="Email" required />
                <TextInput
                  name="email"
                  value={email}
                  onChange={handleChange}
                  helperText={emailStatus.helperText}
                  color={emailStatus.color}
                />
              </Row>
            </div>
          </Row>
        </Row>
      </Spacing>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        size="large"
        disabled={disabled}
        onClick={() => handleSubmit()}
        style={{
          fontSize: '18px',
          lineHeight: '26px',
          fontWeight: 600,
        }}
      >
        Save
      </Button>
    </div>
  );
};
